export default {
    signin: {
        title: 'Sign in',

        intro: 'Log in',

        username: {
            label: 'Email',
            placeholder: 'email@qualitasequity.com',
        },
        password: {
            label: 'Password',
            placeholder: 'Enter password',
        },
        signinBtn: 'Sign in',
        forceLoginBtn: 'Force sign in',
    },

    signout: {
        title: 'Sign out',
    },
}
